import React from 'react';
import { Col, Row } from 'antd';
import { Aside, Content } from 'pages/authentication/style';
import { Outlet, useLocation } from 'react-router-dom';
import { AuthRoutes } from 'router/Routes';

const AuthLayout = () => {
  const location = useLocation();
  const showAsideContent = !AuthRoutes.some(route => location.pathname.startsWith(route.path!));

  return (
    <Row>
      {showAsideContent && (
        <Col xxl={8} xl={9} lg={12} md={8} xs={24}>
          <Aside>
            <div className="auth-side-content">
              <img src={require('static/img/auth/topShape.png')} alt="" className="topShape" />
              <img src={require('static/img/auth/bottomShape.png')} alt="" className="bottomShape" />
              <Content>
                <img
                  className="auth-content-figure"
                  src={require('static/img/auth/signin.png')}
                  alt=""
                  style={{ marginTop: 150 }}
                  width={'110%'}
                />
              </Content>
            </div>
          </Aside>
        </Col>
      )}

      <Col
        xxl={showAsideContent ? 16 : 24}
        xl={showAsideContent ? 15 : 24}
        lg={showAsideContent ? 12 : 24}
        md={showAsideContent ? 16 : 24}
        xs={24}
      >
        <Outlet />
      </Col>
    </Row>
  );
};

export default AuthLayout;
